import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["relevantTab", "rawTab", "transformationConfig"]
  static values = { url: String }

  open(event) {
    // Check if the click target is the checkbox or within its form
    if (event.target.closest('[data-controller="autosubmit"]') || event.target.type === 'checkbox') {
      return;
    }

    if (this.hasUrlValue && this.urlValue) {
      Turbo.visit(this.urlValue);
    } else {
      console.warn("Settings URL not available or card not configured for action.");
    }
  }

  openWithStream(event) {
    if (this.hasUrlValue && this.urlValue) {
      fetch(this.urlValue, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
        }
      })
        .then((response) => response.text())
        .then((html) => {
          Turbo.renderStreamMessage(html)
        })
    } else {
      console.warn("Settings URL not available or card not configured for action.");
    }
  }

  showRelevantTab(event) {
    let clickEvent = new Event('click')
    this.relevantTabTarget.dispatchEvent(clickEvent)
    this.relevantTabTarget.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  showRawTab(event) {
    let clickEvent = new Event('click')
    this.rawTabTarget.dispatchEvent(clickEvent)
    this.rawTabTarget.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  preventCardAction(event) {
    event.stopPropagation();
  }
}
